export default {
    exportEmployeeData: 'ส่งออกข้อมูลพนักงาน',
    cancel: 'ยกเลิก',
    export: 'ส่งออก',
    employeeInformation: 'ข้อมูลพนักงาน',
    tabletRegisterCode: 'รหัสลงทะเบียนผ่านแท็บเล็ต',
    lineRegisterCode: 'รหัสลงทะเบียนระบบไลน์'
}
